const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue')
const Financeiro = () => System.import('../App/View/Financeiro.vue')
const ContaReceber = () => System.import('../App/View/ContaReceber.vue')

export const FinanceiroRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {path: 'financeiro', component: Financeiro, name: 'financeiro', meta: {auth: true}},
      {path: 'financeiro/cliente', component: ContaReceber, name: 'financeiro-cliente', meta: {auth: true}},
      {path: 'financeiro/contareceber', component: ContaReceber, name: 'financeiro-conta-a-receber', meta: {auth: true}}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/Financeiro/Rotas/Routes.js